import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
export function ScarcityBar() {
  const [spots, setSpots] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => setSpots(s => s > 3 ? s - 1 : s), 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100;
  return <div className="rounded-2xl border border-coral/30 bg-coral-soft p-4" data-id="element-60" data-mp="2b6gxll0817tw">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold text-navy" data-id="element-61" data-mp="2g5l6sbn5b5k8">
        <FlameIcon className="h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-62" data-mp="226lhd1rt6mn0" />
        <span data-id="element-63" data-mp="2755619xsecj2">
          Only <span className="text-coral-dark" data-id="element-64" data-mp="274n1lq0z0s02">{spots} spots</span> left at the promotional price
        </span>
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots claimed" data-id="element-65" data-mp="fqjm4e1kddn">
        <div className="h-full rounded-full bg-coral transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-66" data-mp="2zl9lwb7zpqkg" />
      </div>
      <p className="mt-2 text-center text-xs font-bold uppercase tracking-wide text-coral-dark" data-id="element-67" data-mp="3dbwm67tefoin">
        {Math.round(filled)}% of launch spots already claimed
      </p>
    </div>;
}